import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import InvoiceDetail from "@components/modules/invoices/Detail";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { NavigationProformaInvoice } from "@src/components/widgets/AppSubNav/navigation-invoices/proforma-invoices";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Outgoing invoice detail`}
    navigation={<NavigationProformaInvoice invoiceId={id} />}
  >
    <InvoiceDetail.Proforma id={id} />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/invoices/proforma-invoices/detail")({
  component: RouteComponent,
});
